<app-generic-dashboard
  [pageTitle]="pageTitle"
  [dashboardType]="dashboardType"
  [customTabConfigs]="customTabConfigs"
  [selectedIndex]="selectedTabIndex"
  [useLoadingWrapper]="true"
  [loading]="loading"
  (selectedIndexChange)="onSelectedTabIndexChange($event)">
</app-generic-dashboard>
